import React, { createContext, useContext, useReducer } from 'react';

const loaderContext = createContext();

const reducer = (state, action) => {
  if (action.show) {
    return { isOpen: true, message: action.message };
  } else {
    return { isOpen: false };
  }
};

const LoaderProvider = ({ children }) => {
  const [state, dispatchLoader] = useReducer(reducer, {
    isOpen: false,
  });

  const value = { state, dispatchLoader };

  return (
    <loaderContext.Provider value={value}>{children}</loaderContext.Provider>
  );
};

const useLoader = () => {
  return useContext(loaderContext);
};

export { LoaderProvider, useLoader };
